import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { ActivatedRoute } from '@angular/router';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { ViewModalComponent } from '@scaffold/dialogs/view-modal/view-modal.component';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'scaffold-link',
    templateUrl: './link.component.html',
    styleUrls: ['../../rendered.component.scss', './link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  private _rel_url = '';
  dialogRef: ScaffoldDialogRef;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private route: ActivatedRoute,
    public dialog: ScaffoldDialogService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    let target = this.item.link_target;
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });

    if (this.route && this.route.parent && this.route.parent.component) {
      this.route.parent.url.subscribe(val => {
        let parts = val.map(v => {
          return v.path;
        });
        this._rel_url = '/' + parts.join('/') + '/';
        if (target && target === 'child') {
          this._rel_url +=
            this.info.reference_type + '/' + this.info.reference_id;
        } else {
          this._rel_url += this.info.type + '/' + this.info.id;
        }
      });
    } else {
      this._rel_url = '/';
      if (target && target === 'child') {
        this._rel_url +=
          this.info.reference_type + '/' + this.info.reference_id;
      } else {
        this._rel_url += this.info.type + '/' + this.info.id;
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  // Needs from a service
  // openLinkHandler

  openLink(event) {
    this.renderedService.openLinkHandler(
      event,
      this.info,
      this.route,
      this.item.link_target
    );
  }

  openViewLink(event: Event, item: any, mode: any, target) {
    event.preventDefault();
    //for module items
    if (target && target === 'child' /* && item.rootItem*/) {
      this.openViewHandler(mode, {
        type: item.reference_type,
        id: item.reference_id,
      });
    } else {
      this.openViewHandler(mode, item);
    }
  }

  openViewHandler(mode: any, item: any) {
    let settings: any = {
      context: {
        data: {
          size: this.item?.modal_width_size || 'wide',
          mode: mode,
          item: item || this.info.children || this.info,
          //   parent: parent || this.info
        },
      },
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, settings);
    this.dialogRef.onClose.subscribe(result => {
      console.log(result);
      console.log(this.item);
      console.log(this.info);
      if (result && (result !== 'string' || result.length > 0)) {
        if (this.item && this.item.list_view) {
        }
      }
    });
  }
}
